import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import { CampaignForm, RightSidebar } from 'components';
import { CampaignFormProvider } from 'context';
import { useCampaign } from 'hooks';
import { generatePath, useLocation, useNavigate } from 'react-router-dom';
import { CampaignStep, RouteList } from 'types';

export function HomePage() {
  const { getCampaignQuery } = useCampaign();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  useEffect(() => {
    if (!getCampaignQuery.isLoading && getCampaignQuery.isFetched) {
      const campaign = getCampaignQuery.data?.campaign;
      if (campaign?.state === 'ready' && campaign?.cockpitId) {
        const path = generatePath(RouteList.CampaignOverview, { campaignId: String(campaign?.id) });
        navigate(path);
      }
    }
  }, [getCampaignQuery.data?.campaign, getCampaignQuery.isFetched, getCampaignQuery.isLoading, navigate]);

  return (
    <Grid container spacing={6}>
      <CampaignFormProvider startStep={searchParams.get('startStep') as CampaignStep}>
        {/* order will put this element after right sidebar on mobile */}
        <Grid item xs={12} md={9} sx={{ order: { xs: 1, sm: 0 } }}>
          <CampaignForm />
        </Grid>
        <Grid item xs={12} md={3}>
          <RightSidebar />
        </Grid>
      </CampaignFormProvider>
    </Grid>
  );
}
